// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-rating-card {
    border: none;
    border-bottom: 2px solid #EDEDED;
    border-radius: 0;
    border-radius: initial;
    padding: 20px 0px;
}

.user-image img {
    height: 50px;
    width: 50px;
}

.user-name h6 {
    font-weight: 600;
    margin-bottom: 0px;
}

.user-rating-card {
    display: flex;
    flex-direction: row;
    align-items: baseline;
}

.rating-detail {
    display: flex;
    column-gap: 80px;
    align-items: baseline;
}

.review-time {
    color: var(--tGrey);
}

.rated-star {
    margin-top: -20px;
}

.review-subject p {
    font-weight: 500;
    padding-top: 10px;
    margin-bottom: 10px;
}

.review-para p,
.like-txt p {
    color: var(--tGrey);
}

.like-review {
    display: flex;
    column-gap: 20px;
}

.like-img img {
    height: 20px;
    width: 20px;
}

.like-txt p {
    margin-top: 3px;
}

@media (max-width: 767px) {
    .rating-detail {
        column-gap: 13%;
    }
}


/* Define the styles for the half-colored star */
.half-star {
    position: relative;
    color: #ccc;
    /* Color for half-colored stars */
}

/* Define the styles for the half-colored star's pseudo-element */
.half-star::before {
    content: "★";
    /* Unicode character for star */
    position: absolute;
    left: 0;
    width: 50%;
    /* Width determines how much of the star is colored */
    overflow: hidden;
    color: #f8ce0b;
    /* Color for the grey part of the half-colored star */
    -webkit-background-clip: text;
            background-clip: text;
}`, "",{"version":3,"sources":["webpack://./src/component/common/cards/RatingCard.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gCAAgC;IAChC,gBAAoB;IAApB,sBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;;AAGA,gDAAgD;AAChD;IACI,kBAAkB;IAClB,WAAW;IACX,iCAAiC;AACrC;;AAEA,iEAAiE;AACjE;IACI,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,qDAAqD;IACrD,gBAAgB;IAChB,cAAc;IACd,qDAAqD;IACrD,6BAAqB;YAArB,qBAAqB;AACzB","sourcesContent":[".user-rating-card {\n    border: none;\n    border-bottom: 2px solid #EDEDED;\n    border-radius: unset;\n    padding: 20px 0px;\n}\n\n.user-image img {\n    height: 50px;\n    width: 50px;\n}\n\n.user-name h6 {\n    font-weight: 600;\n    margin-bottom: 0px;\n}\n\n.user-rating-card {\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n}\n\n.rating-detail {\n    display: flex;\n    column-gap: 80px;\n    align-items: baseline;\n}\n\n.review-time {\n    color: var(--tGrey);\n}\n\n.rated-star {\n    margin-top: -20px;\n}\n\n.review-subject p {\n    font-weight: 500;\n    padding-top: 10px;\n    margin-bottom: 10px;\n}\n\n.review-para p,\n.like-txt p {\n    color: var(--tGrey);\n}\n\n.like-review {\n    display: flex;\n    column-gap: 20px;\n}\n\n.like-img img {\n    height: 20px;\n    width: 20px;\n}\n\n.like-txt p {\n    margin-top: 3px;\n}\n\n@media (max-width: 767px) {\n    .rating-detail {\n        column-gap: 13%;\n    }\n}\n\n\n/* Define the styles for the half-colored star */\n.half-star {\n    position: relative;\n    color: #ccc;\n    /* Color for half-colored stars */\n}\n\n/* Define the styles for the half-colored star's pseudo-element */\n.half-star::before {\n    content: \"★\";\n    /* Unicode character for star */\n    position: absolute;\n    left: 0;\n    width: 50%;\n    /* Width determines how much of the star is colored */\n    overflow: hidden;\n    color: #f8ce0b;\n    /* Color for the grey part of the half-colored star */\n    background-clip: text;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
